import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { employerHasPermission, isSubcontractorOnlyShell } from '../utils/userDashboardUi';
import './SettingsDropdown.css';

const SettingsDropdown = ({ user, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const isSuperAdminUser = Boolean(
    user && (user.role === 'superuser' || user.role === 'super_admin')
  );

  const showUsersItem =
    Boolean(user) &&
    !isSuperAdminUser &&
    !isSubcontractorOnlyShell(user) &&
    employerHasPermission(user, 'view_users');

  const showProfileMenu = Boolean(user) && !isSuperAdminUser;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const go = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <div className="settings-dropdown-container" ref={dropdownRef}>
      <button
        type="button"
        className="settings-dropdown-button"
        onClick={() => setIsOpen((o) => !o)}
        aria-label="Account menu"
        aria-expanded={isOpen}
        aria-haspopup="menu"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </button>

      {isOpen && (
        <div className="settings-dropdown-menu" role="menu">
          {showProfileMenu ? (
            <>
              <button
                type="button"
                role="menuitem"
                className="settings-dropdown-item"
                onClick={() => go('/profile')}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                <span>Profile</span>
              </button>
              {showUsersItem ? (
                <button
                  type="button"
                  role="menuitem"
                  className="settings-dropdown-item"
                  onClick={() => go('/profile/users')}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                  <span>Users</span>
                </button>
              ) : null}
            </>
          ) : null}
          {onLogout ? (
            <button
              type="button"
              role="menuitem"
              className="settings-dropdown-item"
              onClick={() => {
                setIsOpen(false);
                onLogout();
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span>Logout</span>
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default SettingsDropdown;
